import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageQueryService } from '@certemy/ui-components';
import { FeesStepInstance } from 'services/professional/step/step.interface';
import { getFeeFormOptionsForPayment } from 'components/modal-windows/step-details/fees-details/fees-details.modal.component';
import { PaymentFormService } from 'features/payment-form';
import { getPaymentData } from 'features/payment-form/payment-form.constants';
import _get from 'lodash-es/get';

@Component({
  selector: 'cm-voucher-confirm-screen',
  templateUrl: './voucher-confirm-screen.component.html',
  styleUrls: ['./voucher-confirm-screen.component.scss'],
})
export class VoucherConfirmScreenComponent {
  @Input() voucherValue: string;
  @Input() step: FeesStepInstance;
  @Output() cancel = new EventEmitter();
  @Output() dismissModal = new EventEmitter();
  @Output() back = new EventEmitter();

  constructor(private messageQueryService: MessageQueryService, private paymentService: PaymentFormService) {}

  submitVoucher() {
    const feeFormOptions = _get(this.step.content, 'feesFormFields.length')
      ? getFeeFormOptionsForPayment(this.step.content.feesFormFields)
      : [];
    const paymentData = getPaymentData('optionInstances', feeFormOptions);
    this.paymentService
      .submitVoucher(`/certification_step_instance/${this.step.step_instance_id}/pay`, this.voucherValue, paymentData)
      .subscribe(
        () => {
          this.messageQueryService.addMessage('Your payment was successful.<br>Thank you!');
          this.cancel.emit();
        },
        (err) => {
          if (!err.handled) {
            this.messageQueryService.addErrorMessage(
              'An error occurred while submitting voucher. Please try again later.',
            );
          }
        },
      );
  }
}
